import { Component, Input } from '@angular/core';

@Component({
  selector: 'hb-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss'],
})
export class LineChartComponent {
  @Input() data: Array<{ name: Date; value: number }>;
  @Input() view: number[];

  public colorScheme = {
    domain: ['#000000'],
  };

  constructor() {}
}
